/**
 * 报关贴纸管理- 报关品名进度跟踪
 *
 * @author FJJ
 * @version 1.0
 * @copyright 2021-2021, all rights reserved. Essa.cn
 */
import React, {Fragment} from 'react';
import {  Spin,} from "antd";
import CommonBreadcrumb from "@components/CommonBreadcrumb";
import Lang from "@/components/Lang/Lang";
import AutoFetchTable from "@/components/AutoFetchTable/AutoFetchTable";
import dayjs from 'dayjs';
import "./List.less";
import {Link} from "react-router-dom";
class CustomsCoding extends React.Component{
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            searchFormOptions:[
                {
                    name:'keyword',
                    cnTitle:'客户',
                    cnTitleId:'KeHu',
                    cnPlaceholder:'请输入客户编码或名称',
                    cnPlaceholderId:'QingShuRuCaiGouShangBianMaHuoMingCheng'
                },
                {
                    name:'poCode',
                    cnTitle:'PO单号',
                    cnTitleId:'PODanHao',
                    cnPlaceholder:'请输入PO单号',
                    cnPlaceholderId:'QingShuRuPODanHao'
                }
            ],
            columns:[
                {
                    cnTitle: '客户信息',
                    dataIndex: 'buyerCode',
                    cnTitleId: 'KeHuXinXi',
                    render: (buyerCode, record) => {
                        return(<Fragment>
                            <p className={'span-red'}><Link to={`/customer/detail?id=${record.buyerId}`} target={'_blank'}>{buyerCode}</Link></p>
                            <p className={'blackLink'}><Link to={`/customer/detail?id=${record.buyerId}`} target={'_blank'}>{record.buyerName}</Link></p>
                        </Fragment>)}
                },
                {
                    cnTitle: 'PO单号',
                    dataIndex: 'poCode',
                    cnTitleId: 'PODanHao',
                },
                {
                    cnTitle: '下单时间',
                    dataIndex: 'poCreateTime',
                    cnTitleId: 'XiaDanShiJian',
                    render: (startTime, record) => startTime?dayjs(startTime).format('YYYY-MM-DD HH:mm'):'-'
                },
                {
                    cnTitle: '订单提交时长',
                    dataIndex: 'poCreateTime',
                    cnTitleId: 'DingDanTiJiaoShiZhang',
                    type:'millisecondToTime',
                },
                {
                    cnTitle: '当前节点',
                    dataIndex: 'eventName',
                    cnTitleId: 'DangQianJieDian',
                },
                {
                    cnTitle: '当前处理人',
                    dataIndex: 'handleName',
                    cnTitleId: 'DangQianChuLiRen',
                },
            ],
        }
    }
    render(){
        const { loading,searchFormOptions,columns, } = this.state;

        const currPageName = Lang({id: "BaoGuanPinMingJinDuGenZong",default: "报关品名进度跟踪"});
        return (<Spin tip='loading' spinning={loading}>
                <CommonBreadcrumb list={[{ name:currPageName}]}></CommonBreadcrumb>
                <div className={'progressTrackingList'}>
                    <div className={'title fw_700 font_18'}>{currPageName}</div>
                    <AutoFetchTable columns={columns}
                                    flagShowReset={false}
                                    searchFormOptions={searchFormOptions}
                                    fetchApi={'/service/mg/sticker/track/schedule-list'} />
                </div>
            </Spin>

        )
    }
}

export default CustomsCoding;
